module.exports = __webpack_public_path__ + "static/media/noti6.dc409015.png";